export default "__VITE_ASSET__BuGz3x6A__"